import { render, staticRenderFns } from "./EditKnowhowForm.vue?vue&type=template&id=4fe47153&"
import script from "./EditKnowhowForm.vue?vue&type=script&lang=js&"
export * from "./EditKnowhowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports